/* RESPONSIBLE TEAM: team-standalone */

import { inject as service } from '@ember/service';
import Controller from '@ember/controller';
import RouteRegexes from 'embercom/lib/route-regexes';
import type RouterService from '@ember/routing/router-service';

/* eslint-disable ember/no-controllers */
export default class StandaloneController extends Controller {
  @service declare router: RouterService;

  get isOnTestingRoute() {
    return RouteRegexes.standalone.testing.test(this.router.currentRouteName);
  }

  get isOnFinAIAgentAnalyzeRoute() {
    return RouteRegexes.standalone.analyze.test(this.router.currentRouteName);
  }
}
